import Amplitude from "amplitude-js";
import ReactGA4 from "react-ga4";
import generalSettings from "./settings";
import type { InitOptions } from "react-ga4/types/ga4";

class Analytics {
  ga4Initialize = false;
  setUp = () => {
    if (generalSettings.amplitudeApiKey) {
      Amplitude.getInstance().init(generalSettings.amplitudeApiKey, undefined, {
        logLevel: "ERROR",
      });
    }

    const ga4Settings = generateGA4Options([
      process.env.REACT_APP_TRACKING_ID, // Google Analytics property for the whole org
      process.env.REACT_APP_GA_MEASUREMENT_ID, // Google Analytics property for Connect
    ]);

    if (ga4Settings.length) {
      ReactGA4.initialize(ga4Settings);
      this.ga4Initialize = true;
    }
  };

  log = (event: string, extraData?: object): void => {
    const [category = "general", action = event] = event.split(":");
    if (this.ga4Initialize) {
      ga4Event(category, action, extraData);
    }
    if (Amplitude.getInstance().getSessionId()) {
      Amplitude.getInstance().logEvent(event, extraData);
    }
  };
}

function ga4Event(category: string, action: string, extraData?: object) {
  // Guard against an empty object: `{}` is truthy, and useAnalyticsLog defaults
  // extraData to `{}`, so `if (extraData)` alone would call ReactGA4.set({}) and
  // trigger react-ga4's "empty `fieldsObject` given to .set()" console warning
  // (forwarded to Datadog via forwardConsoleLogs).
  if (extraData && Object.keys(extraData).length > 0) {
    ReactGA4.set(extraData);
  }

  ReactGA4.event({ category, action });
}

function generateGA4Options(trackerIds: (string | void)[]): InitOptions[] {
  const options: InitOptions[] = [];

  trackerIds.forEach((trackingId) => {
    if (!!trackingId) {
      options.push({ trackingId });
    }
  });

  return options;
}

const analytics = new Analytics();

export default analytics;
